import React from 'react';
import type { HealthState } from '../hooks/useHealthCheck';

export interface HealthStatusPillProps {
  label: string;
  status: HealthState;
}

const STATUS_CONFIG: Record<HealthState, { dot: string; aria: string }> = {
  pending: { dot: 'bg-gray-300', aria: '確認中' },
  ok: { dot: 'bg-green-500', aria: '正常' },
  error: { dot: 'bg-red-500', aria: '応答なし' },
};

export const HealthStatusPill: React.FC<HealthStatusPillProps> = ({ label, status }) => {
  const { dot, aria } = STATUS_CONFIG[status];
  return (
    <span
      className="inline-flex items-center gap-1.5 text-xs text-gray-500"
      aria-label={`${label}: ${aria}`}
      title={`${label}: ${aria}`}
    >
      <span className={`inline-block w-2 h-2 rounded-full ${dot}`} aria-hidden="true" />
      <span>{label}</span>
    </span>
  );
};
